import {
	HomeMenuItemModalRule,
	HomeMenuItemProcessingRule,
	HomeProcessingRule,
	HomeQuantityChangeRule,
	HomeSingleProductOrderRule,
	HomeSingleProductFormRule,
	HomeSingleProductSubmissionRule,
	HomeSingleProductDisplayRule,
	HomeSuggestedProductAvailabilityRule,
} from './interfaces';
import {
	homeAuthenticationRule,
	homeEmptyProductsRule,
	homeUserIconRule,
	homeDeliveryValidityRule,
	homeDeliveryModeRule,
	homeSwitchOrderTypeRule,
	homeAddressByModeRule,
	homeMenuItemProductRule,
	homeMenuItemPricingRule,
	homeMenuItemCartRule,
	homeMenuItemQuantityRule,
	homeMenuItemStockRule,
	homeMenuItemModalRule,
	homeQuantityChangeRule,
	homeSingleProductCartIdentityRule,
	homeSingleProductCartQuantityRule,
	homeSingleProductChannelRule,
	homeSingleProductFormDataRule,
	homeSingleProductOriginalChannelRule,
	homeSingleProductResolveArticleRule,
	homeSingleProductMergeArticleRule,
	homeSingleProductTypeRule,
	homeSingleProductFormChannelRule,
	homeSingleProductFormValueRule,
	homeSingleProductSelectedPriceRule,
	homeSingleProductQuantityRule,
	homeSingleProductSpecialPriceRule,
	homeSingleProductActiveModifierCountsRule,
	homeSingleProductLongModeRule,
	homeSingleProductModifierGroupsRule,
	homeSingleProductModifierMinimumRule,
	homeSingleProductMultiplePricesRule,
	homeSingleProductQuantityValidationRule,
	homeSingleProductSubmissionRule,
	homeSuggestedProductAvailabilityRule,
	homeSuggestedProductStockRule,
} from './rules';

export class HomeFactory {
	createRules(): HomeProcessingRule[] {
		return [
			homeAuthenticationRule,
			homeEmptyProductsRule,
			homeDeliveryValidityRule,
			homeDeliveryModeRule,
			homeSwitchOrderTypeRule,
			homeAddressByModeRule,
			homeUserIconRule,
		];
	}

	createMenuItemRules(): HomeMenuItemProcessingRule[] {
		return [
			homeMenuItemProductRule,
			homeMenuItemPricingRule,
			homeMenuItemCartRule,
			homeMenuItemQuantityRule,
			homeMenuItemStockRule,
		];
	}

	createMenuItemModalRule(): HomeMenuItemModalRule {
		return homeMenuItemModalRule;
	}

	createQuantityChangeRule(): HomeQuantityChangeRule {
		return homeQuantityChangeRule;
	}

	createSingleProductOrderRules(): HomeSingleProductOrderRule[] {
		return [
			homeSingleProductResolveArticleRule,
			homeSingleProductFormDataRule,
			homeSingleProductOriginalChannelRule,
			homeSingleProductChannelRule,
			homeSingleProductQuantityRule,
			homeSingleProductSpecialPriceRule,
			homeSingleProductTypeRule,
			homeSingleProductCartIdentityRule,
			homeSingleProductCartQuantityRule,
			homeSingleProductMergeArticleRule,
		];
	}

	createSingleProductFormRules(): HomeSingleProductFormRule[] {
		return [
			homeSingleProductFormChannelRule,
			homeSingleProductSelectedPriceRule,
			homeSingleProductFormValueRule,
		];
	}

	createSingleProductSubmissionRules(): HomeSingleProductSubmissionRule[] {
		return [
			homeSingleProductQuantityValidationRule,
			homeSingleProductActiveModifierCountsRule,
			homeSingleProductModifierMinimumRule,
			homeSingleProductSubmissionRule,
		];
	}

	createSingleProductDisplayRules(): HomeSingleProductDisplayRule[] {
		return [
			homeSingleProductModifierGroupsRule,
			homeSingleProductMultiplePricesRule,
			homeSingleProductLongModeRule,
		];
	}

	createSuggestedProductAvailabilityRules(): HomeSuggestedProductAvailabilityRule[] {
		return [
			homeSuggestedProductAvailabilityRule,
			homeSuggestedProductStockRule,
		];
	}
}
